import React, { Component } from 'react'
import {Editor, EditorState, RichUtils, convertFromRaw} from 'draft-js'
import './style.scss'
import _isEqual from 'lodash/isEqual'

 const styleMap = {
   CODE: {
     backgroundColor: 'rgba(0, 0, 0, 0.05)',
     fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
     fontSize: 14,
     padding: 1,
   },
 }
 function getBlockStyle(block) {
   switch (block.getType()) {
     case 'blockquote': return 'RichEditor-blockquote'
     default: return null
   }
 }
 class StyleButton extends React.Component {
   constructor() {
     super()
     this.onToggle = (e) => {
       e.preventDefault()
       this.props.onToggle(this.props.style)
     }
   }
   render() {
     let className = 'RichEditor-styleButton'
     if (this.props.active) {
       className += ' RichEditor-activeButton'
     }
     return (
       <span className={className} onMouseDown={this.onToggle}>
         {this.props.label}
       </span>
     )
   }
 }
 const BLOCK_TYPES = [
   // {label: 'H1', style: 'header-one'},
   // {label: 'H2', style: 'header-two'},
   // {label: 'H3', style: 'header-three'},
   // {label: 'H4', style: 'header-four'},
   // {label: 'H5', style: 'header-five'},
   // {label: 'H6', style: 'header-six'},
   // {label: 'Blockquote', style: 'blockquote'},
   {label: 'UL', style: 'unordered-list-item'},
   {label: 'OL', style: 'ordered-list-item'},
   {label: 'Code Block', style: 'code-block'},
 ]
 const BlockStyleControls = (props) => {
   const {editorState} = props
   const selection = editorState.getSelection()
   const blockType = editorState
     .getCurrentContent()
     .getBlockForKey(selection.getStartKey())
     .getType()
   return (
     <div>
       {BLOCK_TYPES.map((type) =>
         <StyleButton
           key={type.label}
           active={type.style === blockType}
           label={type.label}
           onToggle={props.onToggle}
           style={type.style}
         />
       )}
     </div>
   )
 }
 var INLINE_STYLES = [
   {label: 'Bold', style: 'BOLD'},
   {label: 'Italic', style: 'ITALIC'},
   {label: 'Underline', style: 'UNDERLINE'}
   //{label: 'Monospace', style: 'CODE'},
 ]
 const InlineStyleControls = (props) => {
   const currentStyle = props.editorState.getCurrentInlineStyle()

   return (
     <div>
       {INLINE_STYLES.map((type) =>
         <StyleButton
           key={type.label}
           active={currentStyle.has(type.style)}
           label={type.label}
           onToggle={props.onToggle}
           style={type.style}
         />
       )}
     </div>
   )
 }

let timer

class WYSIWYG extends Component {

  constructor(props) {
    super(props)
    this.state = {
      editorState: EditorState.createEmpty()
    }
    this.onChange = this.onChange.bind(this)
    this.toggleBlockType = this._toggleBlockType.bind(this)
    this.toggleInlineStyle = this._toggleInlineStyle.bind(this)

  }

  onChange (editorState) {
    this.setState({editorState})
    clearTimeout(timer)
    timer = setTimeout(() => {
      this.props.action(this.state.editorState)
    }, 300)
  }

  componentDidMount () {
    if (this.props.content) {
      console.log('1')
      const rawContentFromStore = convertFromRaw(JSON.parse(this.props.content));
      this.setState((state) => ({
        editorState: EditorState.createWithContent(rawContentFromStore)
      }))
    }

  }

  componentDidUpdate (prevProps) {
    if (this.props.content && !_isEqual(prevProps.content, this.props.content)) {
      const rawContentFromStore = convertFromRaw(JSON.parse(this.props.content));
      this.setState((state) => ({
        editorState: EditorState.createWithContent(rawContentFromStore)
      }))
    }
  }

  _toggleBlockType(blockType) {
     this.onChange(
       RichUtils.toggleBlockType(
         this.state.editorState,
         blockType
       )
     )
   }

   _toggleInlineStyle(inlineStyle) {
     this.onChange(
       RichUtils.toggleInlineStyle(
         this.state.editorState,
         inlineStyle
       )
     )
   }

  render () {

    return (
      <div className='wysiwyg'>

      <div className='panel panel-default'>
        <div className='panel-body'>
        <div className="RichEditor-controls">
          <BlockStyleControls
            editorState={this.state.editorState}
            onToggle={this.toggleBlockType}
          />
          <InlineStyleControls
            editorState={this.state.editorState}
            onToggle={this.toggleInlineStyle}
          />
          <span className="clearfix"></span>
          </div>
          <div className='RichEditor-editor' onClick={this.focus}>
            <Editor
              blockStyleFn={getBlockStyle}
              customStyleMap={styleMap}
              editorState={this.state.editorState}
              handleKeyCommand={this.handleKeyCommand}
              keyBindingFn={this.mapKeyToEditorCommand}
              onChange={this.onChange}
              ref="editor"
              spellCheck={true}
            />
          </div>
          </div>
          </div>
        </div>
    )
  }
}

export default WYSIWYG



// WEBPACK FOOTER //
// ./src/views/components/WYSIWYG/index.js